import getTypesAereoporti from './get-types-aereoporti'
import getTypesRating from './get-types-rating'

export default {
  getTypesAereoporti,
  getTypesRating
}



// WEBPACK FOOTER //
// ./src/front/actions/types/index.js